module.exports = __webpack_public_path__ + "static/media/logo-pythoncerrado.c97a6dce.png";